import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getArts } from "../../../../actions/arts";
import { clearNovedadesConectividad, clearWsmlartXmlPreview, getNovedadesConectividad, getWsmlartXmlPreview, postWSMLARTNovedades, } from "../../../../actions/connectivityResponse";
import { openEditForm, setFormsGeneralProperties, } from "../../../../actions/formsState";
import { changeSelectProvider, clearAllProviders, getAllProviders } from "../../../../actions/providers";
import { convertDateTimeToNet } from "../../../../utils/datetimeUtils";
import snackbarUtils from "../../../../utils/snackbarUtils";
import XmlViewerDialog from "../../../commons/dialog/xmlViewerDialog";
import { formBehaviourEnum } from "../../../commons/enum/formEnums";
import FormContainer from "../../forms/formContainer";
import NovedadesSearchForm from "./novedadesSearchForm";
import NovedadesTable from "./novedadesTable";
import RespuestasNovedadesDialog from "./respuestasNovedadesDialog";

const NovedadesSearchContainer = () => {
  const dispatch = useDispatch();
  const providers = useSelector((state) => state.providers.allProvidersOptions);
  const postWSMLARTNovedadesState = useSelector((state) => state.connectivityResponse.postWSMLARTNovedades);
  const wsmlartXmlPreview = useSelector((state) => state.connectivityResponse.wsmlartXmlPreview);
  const art = useSelector((state) => state.arts);
  const roles = useSelector((state) => state.auth.roles);
  const connectivityNews = useSelector((state) => state.connectivityResponse.connectivityNews);
  const loading = art.isFetching;
  const tableLoading = connectivityNews.isFetching || postWSMLARTNovedadesState.isFetching;


  const [respuesta, setRespuesta] = useState(null);
  const [filters, setFilters] = useState(null);
  const [openRespuestasDialog, setOpenRespuestasDialog] = useState(false);
  const [openXmlDialog, setOpenXmlDialog] = useState(false);
  const [xmlFilename, setXmlFilename] = useState("wsmlart.xml");

  useEffect(() => {
    clearAllProviders();
    dispatch(getArts());
  }, [dispatch]);

  const handleOpenEditForm = (rowData) => {
    const isSupport = roles.SOPORTE || roles.ADMIN
    dispatch(changeSelectProvider(rowData.idPrestador, isSupport));

    dispatch(
      setFormsGeneralProperties({
        idSiniestro: rowData.siniestro,
        idArt: rowData.mlCloudCoreArtId,
        artName: rowData.nombreArt,
        documento: rowData.documento,
        trabajador: rowData.trabajador,
        numeroHistoriaClinica: rowData.historiaClinica,
      }),
    );

    dispatch(
      openEditForm(
        rowData.comportamiento.trim(),
        formBehaviourEnum.NOVEDAD_CONECTIVIDAD,
        {
          nroFormulario: rowData.nroFormulario,
        },
        {},
      ),
    );
  };

  const handleOpenRespuestas = (rowData) => {
    setOpenRespuestasDialog(true);
    setRespuesta(rowData);
  };

  const handleCloseRespuestas = (rowData) => {
    setOpenRespuestasDialog(false);
    setRespuesta(null);
  };

  const handleSubmitSelected = (selectedRows) => {
    dispatch(postWSMLARTNovedades(selectedRows)).then(() => {
      snackbarUtils.success("Novedades reenviadas correctamente");
    })
  };

  const handleOpenXmlPreview = (rowData) => {
    const comportamiento = rowData.comportamiento ? rowData.comportamiento.trim().toUpperCase() : "";
    const siniestro = rowData.siniestro;
    const nroFormulario = rowData.nroFormulario;
    const idArt = rowData.mlCloudCoreArtId;

    setXmlFilename(`wsmlart_${comportamiento || "xml"}_${siniestro}_${nroFormulario}.xml`);
    dispatch(getWsmlartXmlPreview(idArt, siniestro, nroFormulario, comportamiento));
    setOpenXmlDialog(true);
  };

  const handleCloseXmlPreview = () => {
    setOpenXmlDialog(false);
    dispatch(clearWsmlartXmlPreview());
  };

  const handleSubmitSearch = (values) => {
    const queryParams = {
      art: values.art,
      startDate: convertDateTimeToNet(values.startDate),
      endDate: convertDateTimeToNet(values.endDate),
      siniestro: values.siniestro,
      dni: values.dni,
      providerId: values.providerId ?? null,
      status: values.status !== "" ? values.status === "true" : null,
    };
    dispatch(getNovedadesConectividad(queryParams));
    setFilters(values);
  };

  const handleArtChange = (artValue) => {
    if (artValue) {
      dispatch(getAllProviders(artValue));
    } else {
      dispatch(clearAllProviders());
    }
  };

  const handleClearNovedadesResults = () => {
    dispatch(clearNovedadesConectividad());
    dispatch(clearAllProviders());
    setFilters(null);
  }

  return (
    <>
      <NovedadesSearchForm
        isSearching={loading}
        providers={providers.data}
        arts={art.list}
        model={filters}
        handleSubmitSearch={handleSubmitSearch}
        onArtChange={handleArtChange}
        handleClearSearch={handleClearNovedadesResults}
      />
      <NovedadesTable
        handleOpenEdit={handleOpenEditForm}
        handleOpenRespuestas={handleOpenRespuestas}
        handleOpenXmlPreview={handleOpenXmlPreview}
        loading={tableLoading}
        namesArts={art.namesArts}
        handleSubmitSelected={handleSubmitSelected}
        data={connectivityNews.data}
      />
      <FormContainer />
      <RespuestasNovedadesDialog
        open={openRespuestasDialog}
        respuesta={respuesta}
        handleClose={handleCloseRespuestas}
      />
      <XmlViewerDialog
        open={openXmlDialog}
        onClose={handleCloseXmlPreview}
        xml={wsmlartXmlPreview?.data?.documentoXml}
        loading={wsmlartXmlPreview?.isFetching}
        title="Visualizar XML"
        filename={xmlFilename}
      />
    </>
  );
};

export default NovedadesSearchContainer;
